/** Camel-cased user surface consumed by UI. */
export interface User {
  id: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  avatarUrl: string;
}

/** Raw API shape returned by /functions/v1/users/me. */
export interface UserData {
  id: string;
  first_name?: string | null;
  last_name?: string | null;
  middle_name?: string | null;
  suffix?: string | null;
  title?: string | null;
  email_address?: string | null;
  avatar_url?: string | null;
  created_at?: string;
  updated_at?: string;
  is_archived?: boolean;
  is_banned?: boolean;
  is_verified?: boolean;
}

export function normalizeUserData(d: UserData): User {
  return {
    id: d.id,
    firstName: d.first_name ?? '',
    lastName: d.last_name ?? '',
    emailAddress: d.email_address ?? '',
    avatarUrl: d.avatar_url ?? '',
  };
}
